import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";

const City = () => {
  const [cityData, setCityData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [countryDrp, setCountryDrpData] = useState([]);
  const [stateDrp, setStateDrpData] = useState([]);
  const [formdata, setFormData] = useState({
    country_id: "",
    state_id: "",
  });

  const getStateDrpData = () => {
    axios
      .post(API_URL.STATE_LIST, { country_id: formdata.country_id })
      .then((res) => {
        setStateDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setStateDrpData(cd);
      });
  };

  const getCountryDrpData = () => {
    axios.post(API_URL.COUNTRY_LIST, {}).then((res) => {
      setCountryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCountryDrpData(cd);
    });
  };

  const getCity = () => {
    axios
      .post(API_URL.CITY_LIST, {
        country_id: formdata.country_id,
        state_id: formdata.state_id,
      })
      .then(
        (res) => {
          if (res.data.status === 1) {
            setCityData(res.data.data);
          }
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          toast.error("Something went wrong..", {
            autoClose: 3000,

          });
        }
      );
  };

  const deleteCity = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CITY_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = cityData.filter((r) => r.id != row.id);
              setCityData(newData);
              toast.success("Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };
  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  useEffect(() => {
    getCity();
  }, [formdata.country_id, formdata.state_id]);

  useEffect(() => {
    getCountryDrpData();
    getStateDrpData();
  }, []);

  useEffect(() => {
    getStateDrpData();
  }, [formdata.country_id]);

  return (
    <>
      <div className="row">
        <div className="col-4">
          <h1>
            City <small className="me-2">({cityData.length})</small>
          </h1>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 300 }}>
              <Select
                placeholder="Select Country"
                options={countryDrp}
                className="form-select-sm"
                style={{ border: "1px solid lightgray" }}
                value={countryDrp.find((r) => r.value == formdata.country_id)}
                styles={styles}
                onChange={(e) =>
                  setFormData({ ...formdata, country_id: e.value })
                }
              />
            </div>
            <div className="form-group mb-0 mr-2" style={{ width: 300 }}>
              <Select
                placeholder="Select State"
                options={stateDrp}
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                value={stateDrp.find((r) => r.value == formdata.state_id)}
                styles={styles}
                onChange={(e) =>
                  setFormData({ ...formdata, state_id: e.value })
                }
              />
            </div>
            <Link to={"/city/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              City
            </Link>
          </div>
        </div>
         <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="">
                        <tr>
                          <th>#</th>
                        <th>Name</th>
                        <th className="text-center" style={{ width: "200px" }}>
                          Actions
                        </th>
                        </tr>
                      </thead>
                      <tbody>
                        {cityData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td style={{ width: "10px" }}>{key + 1}</td>
                            <td>
                              {row.name}
                            </td>
                            <td
                              className="d-flex justify-content-center gap-2"
                              style={{ width: "200px" }}
                            >
                              <Link
                                to={"/city/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteCity(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default City;
